/**
 * Kingdom Minded — All Collections drawer enhancements.
 *
 * The drawer opens and closes on its own via a hidden checkbox, so it still works
 * with JavaScript disabled. This adds only what CSS cannot do:
 *   - ESC closes
 *   - body scroll lock while open
 *   - focus moves into the drawer on open and back to the trigger on close
 *   - the close control responds to Enter/Space (it is a <label>, not a <button>)
 */
(function () {
  var CB_ID = 'km-allcol-cb';

  function init() {
    var cb = document.getElementById(CB_ID);
    if (!cb || cb.dataset.kmBound === '1') return;
    cb.dataset.kmBound = '1';

    var drawer = document.querySelector('[data-km-allcol-drawer]');
    var lastTrigger = null;

    // Remember which trigger opened it so focus can go back there on close.
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('label[for="' + CB_ID + '"]');
      if (t && !t.classList.contains('km-allcol-close') && !t.classList.contains('km-allcol-backdrop')) {
        lastTrigger = t;
      }
    });

    function close() {
      if (!cb.checked) return;
      cb.checked = false;
      sync();
    }

    function sync() {
      var open = cb.checked;
      document.body.classList.toggle('km-allcol-open', open);

      if (open) {
        // Focus the first row so keyboard users land inside the drawer.
        var first = drawer && drawer.querySelector('.km-allcol-row, .km-allcol-close');
        if (first) {
          if (!first.hasAttribute('tabindex') && first.tagName === 'LABEL') first.setAttribute('tabindex', '0');
          try { first.focus({ preventScroll: true }); } catch (err) { first.focus(); }
        }
      } else if (lastTrigger) {
        try { lastTrigger.focus({ preventScroll: true }); } catch (err) { lastTrigger.focus(); }
      }
    }

    cb.addEventListener('change', sync);

    document.addEventListener('keydown', function (e) {
      if (!cb.checked) return;

      if (e.key === 'Escape' || e.key === 'Esc') {
        e.preventDefault();
        close();
        return;
      }

      // Keep Tab inside the drawer while it is open.
      if (e.key === 'Tab' && drawer) {
        var items = drawer.querySelectorAll('a[href], label[tabindex], [tabindex]:not([tabindex="-1"])');
        if (!items.length) return;
        var first = items[0];
        var last = items[items.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    });

    // The close control is a <label>, which does not fire on Enter/Space by default.
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
      var el = document.activeElement;
      if (!el || el.getAttribute('for') !== CB_ID) return;
      e.preventDefault();
      cb.checked = !cb.checked;
      sync();
    });

    // Never leave the page scroll-locked after a navigation restores from bfcache.
    window.addEventListener('pageshow', function () {
      cb.checked = false;
      document.body.classList.remove('km-allcol-open');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
